import { actionCreatorFactory } from 'typescript-fsa';
import { asyncFactory } from 'typescript-fsa-redux-thunk';

import { IState } from '../../IState';

export const actionCreator = actionCreatorFactory('MenuCatalog');
export const actionCreatorAsync = asyncFactory<IState>(actionCreator);
